// extracted by mini-css-extract-plugin
export default {"managePort":"managePortfolio_managePort__PJRb0","wrapper":"managePortfolio_wrapper__bxz-Y","btns":"managePortfolio_btns__JAbTN"};